import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder, } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
export class File extends AutoEncoder {
    getPublicPath() {
        return this.server + "/" + this.path;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], File.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], File.prototype, "server", void 0);
__decorate([
    field({ decoder: StringDecoder })
], File.prototype, "path", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], File.prototype, "size", void 0);
//# sourceMappingURL=File.js.map